"use client"

import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList, Cell } from "recharts"
import { Card, CardContent } from "../Ui/Card.jsx"

const chartData = [
  { month: "March", desktop: 237, mobile: 120 },
  { month: "April", desktop: 73, mobile: 190 },
  { month: "May", desktop: 209, mobile: 130 },
  { month: "June", desktop: 214, mobile: 140 },
]

export function BarChartComponent() {
  return (
    <Card>
      <CardContent>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 10, right: 20, left: 30, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <YAxis
              dataKey="month"
              type="category"
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 12 }}
            />
            <XAxis type="number" hide />
            <Tooltip cursor={{ fill: '#f9f9f9' }} />
            <Bar dataKey="desktop" radius={[10, 10, 10, 10]} barSize={16}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={
                  ['#4072ee', '#b558f6', '#fec400', '#29cb97'][index]
                } />
              ))}
              <LabelList
                dataKey="desktop"
                position="right"
                offset={8}
                fill="#111"
                fontSize={10}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
